import React, { FC, ReactElement, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate, RouteProps } from "react-router-dom";

interface PrivateRouteProps extends RouteProps {
	children: any;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children }): ReactElement => {
	const auth = useContext(AuthContext);
	const userHash = sessionStorage.getItem("userHash");

	return auth.authenticated || userHash ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
